import { useEffect, useState } from 'react';
import { fetchGlobalSettings } from '../fetchDataFromStrapi';
import { BASE_URL } from '../config';

let globalSettingsCache = null;

export function useGlobalSettings() {
  const [globalSettings, setGlobalSettings] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (globalSettingsCache) {
      setGlobalSettings(globalSettingsCache);
      return;
    }

    const loadSettings = async () => {
      try {
        const response = await fetchGlobalSettings();
        const formatted = {
          logoUrl: `${BASE_URL}${response.data.Logo.url}`,
        };

        globalSettingsCache = formatted;
        setGlobalSettings(formatted);
      } catch (err) {
        setError('Fehler beim Laden der globalen Einstellungen');
      }
    };

    loadSettings();
  }, []);

  return { globalSettings, error };
}
